import styled from 'styled-components';

import {Device} from '../../../../constants';

import VBucksImage from './VBucksImage';

const CrewVBucksContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 0;

  ${VBucksImage} {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    max-width: 33em;
    height: auto;
    padding: 0;

    @media screen and (max-width: 1265px) {
      max-width: 18em;
    }

    @media screen and ${Device.tablet} {
      position: relative;
      bottom: unset;
      right: unset;
    }
  }

  @media screen and ${Device.tablet} {
    position: relative;
    bottom: unset;
    right: unset;
    display: flex;
    justify-content: flex-end;
  }
`;

export default CrewVBucksContainer;
